import cardly from './cardly.png'
import eye from './eye.png'
import fitbit from './fitbit.png'
import movie from './movie.png'
import OceanStars from './OS.png'

export const projectsList = [
{
    title: "Cardly",
    Demo: "https://cardly-recoded.netlify.app/",
    Code: "https://github.com/ReCoded-Org/capstone-IQLBPS-flashcard",
    discription :"Learning website give the user the ability of making his sets and cards of new inputs while learning or studying new things as a reference for future.",
    team : "It's a bootcamp capstone project Built with a team of 13 developers and the Senior Tech Lead, Muhannad Noman from Re:Coded",
    tools : ["React","Firebase","TailwindCss"],
    img : cardly
},
{
    title: "Movie Project",
    Demo: "https://bucolic-pika-5194d9.netlify.app/#",
    Code: "https://github.com/hayatzsala/oop-movie",
    discription :"Website for browsing movies and view details and their trailer and rating them.",
    team : "Built the project with a team of 4 developers in Frontend Bootcamp by Re:Coded",
    tools : ["JavaScript","Html","CSS","TMDB Api"],
    img: movie
},
{
    title: "The Third Eye",
    Demo: "https://drive.google.com/file/d/1bjHEe-GftG_ams6pB-63voRk0al0nu54/view",
    Code: "https://docs.google.com/presentation/d/1PMv5eXUWItsZalCJsPZ86bQ2On9Om0y_/edit?usp=sharing&ouid=102080956762172094182&rtpof=true&sd=true",
    discription :"The Third eye is a hardware project consist of a smart stick and helmet for blind people. Could help the user to arrive to his distentions using GPS, and doing daily activity such as going up/downStairs by himself.",
    team: "Build the project as University graduation project (2), with team of 2 students.",
    tools : ["Arduino","NodeMCU","Sensors","GPS-Module"],
    img : eye
},
{
    title: "Fitbit - health tracker application",
    Demo: "https://drive.google.com/file/d/1h6a4X6f1jAZC0EbCB8eLwTVagzqVC9nu/view",
    Code: "https://github.com/hayatzsala/Fitbit",
    discription :"Graduation Proj - Fitbit is a health tracker mobile application, developed on Android and IOS mobile phone. The user can keep track on his weight and his daily steps, and can join different sport classes with international coach.",
    team: "Build the project as University graduation project (1), with team of 2 students.",
    tools : ["React-Native","Google Map Api","Google fit","NodeJs", "MongoDB"],
    img: fitbit
},
{
    title: "OceanStars Travel and Tourism Agency - website",
    Demo: "https://github.com/hayatzsala/OceanstarCo",
    Code: "https://github.com/hayatzsala/OceanstarCo",
    discription :"A website for Travel & tourism agencies provides the functionality of booking hotels and tickets.",
    team: "Build the project as University web development course, with team of 2 students.",
    tools : ["Html","PHP","MySql","CSS"],
    img : OceanStars
},
]